/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Table } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";

import CreateEditSubsectionModal from "./CreateEditModal";
import { showErrorNotification, showSuccessNotification } from "../../../../utils/notification";

const Subsection = ({
  sectionSubsections,
  resources = [],
  sectionId,
  ROOT_URL,
  educatorList = []
}) => {
  const [subsections, setSubsections] = useState([]);
  const [isCreateSubsectionModalOpen, setIsCreateSubsectionModalOpen] = useState(false);
  const [initialValues, setInitialValues] = useState({});

  const handleSubsectionDelete = (subsectionId) => {
    axios
      .post(`${ROOT_URL}/admin/courses/manage/section/subsection/delete`, {
        sectionId,
        subsectionId
      })
      .then((res) => {
        const { updatedSubsections } = res.data;
        setSubsections(updatedSubsections);
        showSuccessNotification("Subsection deleted Successfully");
      })
      .catch(() => {
        showErrorNotification("Internal Server Error");
      });
  };

  const handleCreateFeedbackLink = (subsectionId) => {
    axios
      .post(`${ROOT_URL}/admin/courses/manage/section/subsection/generate-feedback-link`, {
        sectionId,
        subsectionId
      })
      .then((res) => {
        const { updatedSubsections } = res.data;
        setSubsections(updatedSubsections);
        showSuccessNotification("Feedback Link generated Successfully");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleCreateEditSubsection = (values) => {
    if (initialValues?._id !== undefined) {
      axios
        .post(`${ROOT_URL}/admin/courses/manage/section/subsection/edit`, {
          subsectionParams: values,
          subsectionId: initialValues._id,
          sectionId
        })
        .then((res) => {
          const { updatedSubsections } = res.data;
          setSubsections(updatedSubsections);
          setIsCreateSubsectionModalOpen(false);
          showSuccessNotification("Subsection edited Successfully");
        })
        .catch(() => {
          showErrorNotification("Internal Server Error");
        });
    } else {
      axios
        .post(`${ROOT_URL}/admin/courses/manage/section/subsection/create`, {
          subsectionParams: values,
          sectionId
        })
        .then((res) => {
          const { updatedSubsections } = res.data;
          setSubsections(updatedSubsections);
          setIsCreateSubsectionModalOpen(false);
          showSuccessNotification("Subsection created Successfully");
        })
        .catch(() => {
          showErrorNotification("Internal Server Error");
        });
    }
  };

  const columns = [
    {
      title: "Name",
      key: "name",
      render: (row) => row.name + (row?.hidden === true ? " (Hidden)" : "")
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description"
    },
    {
      title: "Video Link",
      dataIndex: "videoLink",
      key: "videoLink"
    },
    {
      title: "Educator",
      dataIndex: "educatorName",
      key: "educatorName"
    },
    {
      title: "Feedback Link",
      dataIndex: "lectureFeedbackSurveyLink",
      key: "lectureFeedbackSurveyLink"
    },
    {
      title: "Source",
      dataIndex: "sourceType",
      key: "sourceType",
      render: (sourceType) => sourceType || "VIMEO"
    },
    {
      title: "Sequence Order",
      dataIndex: "sequenceOrder",
      key: "sequenceOrder"
    },
    {
      title: "Actions",
      key: "action",
      render: (row) => (
        <div
          id="section_subsections_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            flexWrap: "wrap"
          }}
        >
          <Button
            type="primary"
            onClick={() => {
              setInitialValues(row);
              setIsCreateSubsectionModalOpen(true);
            }}
          >
            Edit
          </Button>
          <Button
            type="primary"
            onClick={() => {
              handleCreateFeedbackLink(row._id);
            }}
          >
            Generate feedback link
          </Button>
          <Button
            type="primary"
            danger
            onClick={() => {
              handleSubsectionDelete(row._id);
            }}
          >
            Delete
          </Button>
        </div>
      )
    }
  ];

  useEffect(() => {
    setSubsections(sectionSubsections);
  }, []);

  return (
    <div>
      <div style={{ marginBottom: "1em" }}>
        <Button
          type="primary"
          onClick={() => {
            setInitialValues({});
            setIsCreateSubsectionModalOpen(true);
          }}
        >
          {" "}
          Create New Subsection
        </Button>
      </div>
      <Table
        columns={columns}
        bordered
        pagination={false}
        dataSource={subsections}
        scroll={{ x: "max-content" }}
      />
      {isCreateSubsectionModalOpen === true && (
        <CreateEditSubsectionModal
          isModalOpen={isCreateSubsectionModalOpen}
          setIsModalOpen={setIsCreateSubsectionModalOpen}
          initialValues={initialValues}
          isEdit={initialValues?._id !== undefined}
          handleCreateEdit={handleCreateEditSubsection}
          educatorList={educatorList}
          resources={resources}
        />
      )}
    </div>
  );
};

export default Subsection;
